export const STATIC_URL = "http://idabooking.eu:8888/unsafe/";
export const IS_CDN = false;
export const ID_CONFIG = 13;
export const STRUCTURE_NAME = "Agriturismo all'Albaro";
export const UUID = "3463F7F7-D6A8-4200-BCD3-FDAF4F1661D9";
export const USE_VIDEO = false;
export const COLOR = "stone";
